
namespace GeniuzPOS.Purchase {

    @Serenity.Decorators.registerClass()
    export class ReportPendingPODtGrid extends Serenity.EntityGrid<ReportPendingPODtRow, any> {
        protected getColumnsKey() { return ReportPendingPODtColumns.columnsKey; }
        protected getDialogType() { return ReportPendingPODtDialog; }
        protected getIdProperty() { return ReportPendingPODtRow.idProperty; }
        protected getInsertPermission() { return ReportPendingPODtRow.insertPermission; }
        protected getLocalTextPrefix() { return ReportPendingPODtRow.localTextPrefix; }
        protected getService() { return ReportPendingPODtService.baseUrl; }
    constructor(container: JQuery) {
        super(container);
    }

}

    


       
}